import { Notification, Loading } from "element-ui";

import { read, utils, writeFile } from "xlsx";

// import FileSaver from 'file-saver'

import { setStore, getStore, removeStore } from "@/util/store";
import request from "@/router/axios";
import { formatDate } from "@/util/tools";

/**
 * 分割时间(format: '2023-01-01')
 * @param {string} startTime 开始时间
 * @param {string} endTime 结束时间
 * @param {number} intervalDays 分割时间天数，以intervalDays天为一组
 * @returns [{startDate: '', endDate: ''}...]
 */
function splitTimeRange(startTime, endTime, intervalDays) {
  const result = [];

  // 将字符串日期转换为 Date 对象
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);

  // 计算时间间隔的毫秒数
  const intervalMillis = intervalDays * 24 * 60 * 60 * 1000;

  while (startDate <= endDate) {
    const nextEndDate = new Date(startDate.getTime() + intervalMillis - 1);

    // 确保下一个结束日期不超过总结束日期
    const slicedEndDate = nextEndDate <= endDate ? nextEndDate : endDate;

    // 添加时间段到结果数组
    result.push({
      startDate: startDate.toISOString().split("T")[0],
      endDate: slicedEndDate.toISOString().split("T")[0],
    });

    // 更新下一轮的开始日期
    startDate.setTime(slicedEndDate.getTime() + 1);
  }

  return result;
}

/**
 * ...
 * @param {*} blob
 * @returns
 */
function readBlob(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      resolve(event.target.result);
    };

    reader.onerror = function () {
      reject(new Error("Unable to read blob."));
    };

    reader.readAsArrayBuffer(blob);
  });
}

const downloadStore = {
  state: {
    currentList: getStore({ name: "currentList" }) || [],
    historyList: getStore({ name: "historyList" }) || [],
    downloadModal: false,

    isLoading: null,
  },

  getters: {
    getCurrentListOrFirst(state) {
      return state.currentList.length !== 0 ? state.currentList[0] : {};
    },
    getCurrentListOrId(state, id) {
      return state.currentList.length !== 0
        ? state.currentList.find((item) => item.id === id)
        : {};
    },
  },

  mutations: {
    ADD_CURRENT_LIST: (state, list) => {
      // console.log(state, list)
      state.currentList.unshift(list);
      setStore({
        name: "currentList",
        content: state.currentList,
      });
    },

    SET_CURRENT_LIST: (state, currentList) => {
      state.currentList = currentList;

      setStore({
        name: "currentList",
        content: state.currentList,
      });
    },

    ADD_HISTORY_LIST: (state, list) => {
      state.historyList.unshift(list);
      setStore({
        name: "historyList",
        content: state.historyList,
      });
    },

    REMOVE_CURRENT_LIST: (state) => {
      state.currentList = [];
      removeStore({
        name: "currentList",
      });
    },

    REMOVE_HISTORY_LIST: (state) => {
      state.historyList = [];
      removeStore({
        name: "historyList",
      });
    },

    // SET_HISTORY_LIST: (state, historyList) => {
    //   state.historyList = historyList;

    //   setStore({
    //     name: 'historyList',
    //     content: state.historyList,
    //     type: 'local'
    //   })
    // },

    SET_DOWNLOAD_MODAL: (state, downloadModal) => {
      state.downloadModal = downloadModal;
      setStore({
        name: "downloadModal",
        content: state.downloadModal,
        type: "session",
      });
    },

    // ...
    SET_ISLOADING: (state, isLoading) => {
      state.isLoading = isLoading;
    },
  },

  actions: {
    async startDownload({ commit, dispatch, state }, list) {
      list.isDownloading = true;

      list.isPaused = false;

      // 获取文件信息
      const response = await request.head(list.url, {
        headers: {},
        params: {
          ...list.params,
        },
      });

      if (response.status === 200 || response.status === 206) {
        list.fileSize = parseInt(response.headers["content-length"], 10);

        const str = response.headers["content-disposition"];

        list.fileName = str
          ? decodeURIComponent(
              str.split(`attachment;filename=`)[1] ||
                str.split(`attachment;filename*=utf-8''`)[1]
            )
          : "download.zip";

        // 初始化下载任务
        list.startByte = 0;
        list.endByte = Math.min(list.chunkSize, list.fileSize);
        list.progress = 0;

        // 开始下载
        await dispatch("downloadChunk", list);
      } else {
        const newCurrentList = state.currentList.filter(
          (item) => item.id !== list.id
        );
        commit("SET_CURRENT_LIST", newCurrentList);

        Notification.error({
          title: "Info",
          message: "下载失败",
        });
      }
    },

    async downloadChunk({ dispatch }, list) {
      const config = {
        responseType: "blob",
        headers: {
          Range: `bytes=${list.startByte}-${list.endByte}`,
          PadUid: "ddd",
        },
        cancelToken: new request.CancelToken((cancel) => {
          list.axiosCancelToken = cancel;
        }),
        params: {
          ...list.params,
        },
      };

      try {
        const response = await request.get(list.url, config);

        if (response.status === 206 || response.status === 200) {
          const chunk = response.data;

          // 合并分片
          if (!list.file) {
            list.file = chunk;
          } else {
            list.file = new Blob([list.file, chunk]);
          }

          // 更新进度
          list.progress = ((list.endByte + 1) / list.fileSize) * 100;

          // 检查是否下载完整个文件
          if (list.endByte >= list.fileSize || !list.isDownloading) {
            // list.$notify.success({
            //   title: 'Info',
            //   message: '下载完成',
            //   // showClose: false
            // })

            // list.$store.commit('CLEAR_DOWNLOAD_URL')

            list.progress = 0;

            list.isDownloading = false;

            list.isPaused = false;

            // 保存文件到本地
            // list.saveFile(fileName)

            dispatch("saveFile", list);

            return;
          }

          // 下载下一个分片
          list.startByte = list.endByte + 1;
          list.endByte = Math.min(
            list.startByte + list.chunkSize - 1,
            list.fileSize
          );

          // 继续下载（如果用户没有暂停）
          if (!list.isPaused) {
            await dispatch("downloadChunk", list);
          }
        }
      } catch (error) {
        if (request.isCancel(error)) {
          // 请求被取消
          console.log("下载已取消");
        } else {
          // 处理其他错误
          console.error(error);
        }
      }
    },

    pauseDownload(_, list) {
      list.isPaused = true;
      if (list.axiosCancelToken) {
        list.axiosCancelToken("Download paused");
      }
    },

    resumeDownload({ dispatch }, list) {
      if (!list.file) return;
      if (!list.isDownloading) {
        list.isPaused = false;
        dispatch("downloadChunk", list);
      }
    },

    cancelDownload(_, list) {
      list.isDownloading = false;
      if (list.axiosCancelToken) {
        list.axiosCancelToken("Download canceled");
      }
      list.progress = 0;
      list.startByte = 0;
      list.endByte = 0;
      list.file = null;
    },

    saveFile({ state, commit }, list) {
      const blob = new Blob([list.file], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = decodeURIComponent(list.fileName);
      a.click();
      window.URL.revokeObjectURL(url);

      list.completionTime = formatDate(new Date());
      list.file = null;
      commit("ADD_HISTORY_LIST", list);

      const newCurrentList = state.currentList.filter(
        (item) => item.id !== list.id
      );
      commit("SET_CURRENT_LIST", newCurrentList);
    },

    firstDownload({ getters, commit, dispatch }) {
      const list = getters.getCurrentListOrFirst;
      // console.log(list)
      if (Object.keys(list).length === 0) return;
      commit("SET_DOWNLOAD_MODAL", true);
      dispatch("startDownload", list);
    },

    downloadCurrent({ state, commit, dispatch }, list) {
      commit("ADD_CURRENT_LIST", list);

      // console.log(state.currentList)
      if (state.currentList.length > 1) return;

      dispatch("firstDownload");
    },

    // ..........................................
    // ...........以下是最新导出功能...............
    // ................尝试方法...................
    // ..........................................

    // 开始下载
    async startDownloads({ dispatch }, list) {
      list.isDownloading = true;

      list.isPaused = false;

      list.fileIntervalList = splitTimeRange(list.startDate, list.endDate, 5);

      await dispatch("downloadChunks", list);
    },

    // 分段下载
    async downloadChunks({ dispatch, commit }, list) {
      try {
        console.log(list.fileIntervalList);
        if (list.fileIntervalList.length === 0) {
          list.isDownloading = false;

          list.isPaused = false;

          list.isExport = true;

          const loading = Loading.service({
            lock: true,
            text: `${list.fileName}--正在导出中...`,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          commit("SET_ISLOADING", loading);

          setTimeout(() => {
            dispatch("saveFiles", list);
          }, 1000);

          return;
        }

        const config = {
          responseType: "blob",
          cancelToken: new request.CancelToken((cancel) => {
            list.axiosCancelToken = cancel;
          }),
          params: {
            ...list.params,
            startDate: list.fileIntervalList[0].startDate,
            endDate: list.fileIntervalList[0].endDate,
          },
        };

        const response = await request.get(list.url, config);

        if (response.status === 206 || response.status === 200) {
          if (list.fileIntervalList.length === 1) {
            const str = response.headers["content-disposition"];

            list.fileName = str
              ? decodeURIComponent(
                  str.split(`attachment;filename=`)[1] ||
                    str.split(`attachment;filename*=utf-8''`)[1]
                )
              : "download.zip";
          }

          const chunk = await readBlob(response.data);
          // console.log(chunk)

          list.file.push(chunk);

          list.fileIntervalList.shift();

          if (!list.isPaused) {
            await dispatch("downloadChunks", list);
          }
        }
      } catch (error) {
        if (request.isCancel(error)) {
          // 请求被取消
          console.log("下载已取消");
        } else {
          // 处理其他错误
          console.error(error);
        }
      }
    },

    // 当前下载
    downloadCurrents({ commit, dispatch }, list) {
      commit("ADD_CURRENT_LIST", list);

      commit("SET_DOWNLOAD_MODAL", true);

      // if (state.currentList.length > 1) return;

      dispatch("firstDownloads");
    },

    // ...
    firstDownloads({ getters, dispatch }) {
      // console.log(list)

      const list = getters.getCurrentListOrFirst;

      if (Object.keys(list).length === 0) return;

      if (list.isDownloading) return;

      dispatch("startDownloads", list);
    },

    // 导出文件
    saveFiles({ state, commit, dispatch }, list) {
      dispatch("createXlsx", list);

      list.completionTime = formatDate(new Date());

      list.file = [];

      commit("ADD_HISTORY_LIST", list);

      const newCurrentList = state.currentList.filter(
        (item) => item.id !== list.id
      );

      commit("SET_CURRENT_LIST", newCurrentList);

      dispatch("firstDownloads", list);
    },

    // 导出方法
    createXlsx({ state }, list) {
      const mergedWorkbook = utils.book_new();

      let fileList = [];
      let sheet1Name = "";
      list.file.map((item) => {
        const wb = read(item, { type: "array" });

        const sheetName = wb.SheetNames[0];

        const sheetData = wb.Sheets[sheetName];

        const data = utils.sheet_to_json(sheetData);

        fileList = [...fileList, ...data];

        sheet1Name = sheetName;
      });

      const sheet = utils.json_to_sheet(fileList);

      const range = utils.decode_range(sheet["!ref"]);

      sheet["!cols"] = Array.from({ length: range.e.c + 1 }, () => ({
        wch: 15,
      }));

      utils.book_append_sheet(mergedWorkbook, sheet, sheet1Name);

      // const fileUrl = window.URL.createObjectURL(mergedWorkbook)
      // FileSaver.saveAs(new Blob([sheet]), list.fileName, ({
      //   bookType: 'xlsx',
      //   type: 'blob',
      //   mimeType:
      //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
      // }))

      writeFile(mergedWorkbook, list.fileName, {
        bookType: "xlsx",
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });

      state.isLoading.close();
    },
  },
};

export default downloadStore;
